import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Breadcrumb, Grid, Table} from 'semantic-ui-react';
import {Helmet} from "react-helmet";

import CustomDivider from '../../components/extras/CustomDivider';
import LineChartCurrency from '../../components/charts/LineChartCurrency';
import FilterBar from '../../components/reports/FilterBar';
import AlertUpgrade from "../../components/extras/AlertUpgrade";
import localDB from "../../data/localDB";
import UpgradeAccount from "../../components/extras/UpgradeAccount";

class ReportUtilities extends Component {

    constructor() {
        super();
        this.loadData = this.loadData.bind(this);
    }

    loadData(branch_office, date) {
        if(!localDB.checkPlanAccessExclude('reports_view_all')){
            this.refs.utilities_day_chart.loadData(branch_office, 'd', date);
            this.refs.utilities_week_chart.loadData(branch_office, 'w', date);
            this.refs.utilities_month_chart.loadData(branch_office, 'm', date);
            this.refs.utilities_montly_chart.loadData(branch_office, 'my', date);
            this.refs.utilities_year_chart.loadData(branch_office, 'y', date);
        }else {
            this.refs.alert_upgrade.open();
        }
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Gráficos de Utilidades - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/reports'>Informes</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Gráficos de Utilidades</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                {!localDB.checkPlanAccessExclude('reports_view_all') ? <Table>
                    <FilterBar title='Gráficos de Utilidades' callbackGetFilter={this.loadData}/>
                    <Table.Body>
                        <Table.Row>
                            <br/>
                            <Grid stackable textAlign='center'>
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <LineChartCurrency
                                            id='utilities_day_chart'
                                            title='Utilidades Diarias'
                                            ref='utilities_day_chart'
                                            type='utilities'
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <LineChartCurrency
                                            title='Utilidades Semanales'
                                            id='utilities_week_chart'
                                            ref='utilities_week_chart'
                                            type='utilities'
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <LineChartCurrency
                                            title='Utilidades Mensuales'
                                            id='utilities_month_chart'
                                            ref='utilities_month_chart'
                                            type='utilities'
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <LineChartCurrency
                                            title='Utilidades Anuales'
                                            id='utilities_montly_chart'
                                            ref='utilities_montly_chart'
                                            type='utilities'
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                                <Grid.Row columns={2}>
                                    <Grid.Column>
                                        <LineChartCurrency
                                            title='Utilidades desde el origen de los tiempos'
                                            id='utilities_year_chart'
                                            ref='utilities_year_chart'
                                            type='utilities'
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Table.Row>
                    </Table.Body>
                </Table>:<UpgradeAccount/>}
                <AlertUpgrade ref='alert_upgrade' />
            </div>
        );
    }
}

export default ReportUtilities;



// WEBPACK FOOTER //
// ./src/containers/reports/ReportUtilities.js